<template>
  <div class="grid grid-cols-4 grid-rows-1 gap-1 rounded-2xl overflow-hidden mb-6 cursor-zoom-in" v-bind="$attrs">
    <div
      v-for="(image, index) in images.slice(0, 5)"
      :key="image"
      class="size-full aspect-[3/2] first:col-span-4"
      @click="openLightBox(index + 1)"
    >
      <img :src="image" class="size-full object-cover" />
    </div>
    <slot />
  </div>

  <FsLightbox
    :key="images.length"
    :toggler="toggleLightbox"
    :slide="lightboxIndex"
    :sources="lightboxImages"
    type="image"
    disable-local-storage
  />
</template>

<script lang="ts" setup>
// @ts-ignore
import FsLightbox from 'fslightbox-vue/v3'

const props = withDefaults(
  defineProps<{
    images?: string[]
  }>(),
  {
    images: () => []
  }
)

const isLargeScreen = useIsLargeScreen()
const fullSizeDimensions = computed(() => (isLargeScreen.value ? 'width=1200&height=800' : 'width=900&height=600'))
const lightboxImages = computed(() => props.images.map((path) => `${path}?${fullSizeDimensions.value}`))

// true or false means nothing, all it cares is that it's different than before
const toggleLightbox = ref(false)
const lightboxIndex = ref(0)

const openLightBox = (slide: number) => {
  lightboxIndex.value = slide
  toggleLightbox.value = !toggleLightbox.value
}
</script>
